import EdButton from "@frameworks/web/components/generic/edbutton/edButton";
import GridContainer from "@frameworks/web/components/generic/CommonUI/GridContainer";
import React from "react";
import { Col, Row } from "react-bootstrap";
import TicketPortalTab from "./TicketPortalTab";
import mainDi from "@di";
import { useDispatch, useSelector } from "react-redux";
import TicketPortalDesc from "./TicketPortalDesc";
import TicketportalError from "./common/TicketportalError";
import { TicketPortalIssue } from "./constant";
import EdModal from "@frameworks/web/components/generic/edModal";
import { EquityDropdown, } from "@frameworks/web/components/generic/equitydropdown/equitydropdown";
import loader from "@frameworks/web/assets/images/generic/gifLoader.gif";
import NewTicket from "./NewTicket";
import tiketsub from "@frameworks/web/assets/images/features/Ticketportal/ticketsub.svg";
import DeviceContext from "@frameworks/web/components/generic/customHooks/indentifyDevice";
import getScrollTop from "@frameworks/web/components/generic/customHooks/getScrollTop";
import GenericDrawer from "@frameworks/web/components/generic/TOCgeneric/GenericDrawer";
import CreateTicket from "./common/CreateTicket";
import { useNavigate } from "react-router-dom";
import di from "./di/servicelocator";
import { Edelweisslogo } from "@frameworks/web/utils/edelweisslogo-header";
import "../../../stylesheets/components/features/TicketPortal/Tickethidemb.scss";
import * as URLConfig from "@frameworks/web/config/domain";
import ErrorNotification, { ErrorDisplayType } from "../../generic/error";
import { fetchAccountDetails } from "@frameworks/web/redux/reducers/Reports/accountDetailsThunk";
import { getQueryParameterName } from "@frameworks/web/utils/urlHelper";
import { ExtPlatDataRetrieveThunks } from "@frameworks/web/redux/reducers/ExtPlatDataRetrieve";
import { JwtTokenNestThunk } from "@frameworks/web/redux/reducers/JwtTokenNestThunk";
const config = URLConfig.config;
const TicketPortal = (props) => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const device = DeviceContext();
    const topValue = getScrollTop();
    const [openNewTicket, setOpenNewTicket] = React.useState(false);
    const [finalCheck, setFinalCheck] = React.useState(false);
    const [ticketLost, setTicketLost] = React.useState(false);
    const [submitTicket, setSubmitTicket] = React.useState(false);
    const [submitFlag, setSubmitFlag] = React.useState(false);
    const [issueType, setIssueType] = React.useState(TicketPortalIssue[0]);
    const [createTicket, setCreateTicket] = React.useState(false);
    const [totalFileSize, setTotalFileSize] = React.useState(0);
    const [totalAttachment, setTotalAttachment] = React.useState(0);
    const [isShowError, setShowError] = React.useState(true);
    const [tabWiseData, setTabWiseData] = React.useState(null);
    const [description, setDescription] = React.useState("");
    const [countcharcter, setCountCharcter] = React.useState(0);
    const [newTicketAlert, setNewTicketAlert] = React.useState(false);
    const [ticketSubmitFail, setticketSubmitFail] = React.useState(false);
    const [showNewTicket, setShowNewTicket] = React.useState("Ticketportal");
    const showNewTicketVisible = (displayDiv) => {
        setShowNewTicket(displayDiv);
        setOpenNewTicket(false);
    };
    const [selectedTicket, setSelectedTicket] = React.useState({
        ticketId: "",
        status: "",
        desc: "",
        ticketDate: "",
        comments: "",
        closedDate: "",
    });
    const [searchResult, setSearchResult] = React.useState([]);
    const [searchFlag, setSearchFlag] = React.useState(false);
    const getTotalFileSize = (filesize) => {
        setTotalFileSize(filesize);
    };
    const createNewTicketAlert = (flag) => {
        setNewTicketAlert(flag);
    };
    const getDescription = (desc) => {
        setDescription(desc);
    };
    const getTotalAttachment = (filecount) => {
        setTotalAttachment(filecount);
    };
    const getCounter = (wordcount) => {
        setCountCharcter(wordcount);
    };
    const loginToken = getQueryParameterName("jwt_token");
    const accData = decodeURIComponent(getQueryParameterName("acc_data"));
    const platform = getQueryParameterName("platform");
    const userID = getQueryParameterName("UserId");
    const exToken = getQueryParameterName("TokenId");
    const token = getQueryParameterName("token");
    const setJwtToken = () => {
        if (loginToken !== null) {
            localStorage.setItem("jwt_token", loginToken !== null ? loginToken : localStorage.getItem("jwt_token"));
            if (platform === "tx3") {
                localStorage.setItem("lgnSrc", "X");
                dispatch(ExtPlatDataRetrieveThunks(token));
            }
        }
    };
    const setJwtTokenForNestTrader = () => {
        if (userID && exToken) {
            const payload = {
                userId: userID,
                extoken: exToken,
            };
            dispatch(JwtTokenNestThunk(payload));
        }
    };
    React.useEffect(() => {
        if (totalFileSize > 5120) {
            setFinalCheck(false);
        }
    }, [totalFileSize]);
    React.useEffect(() => {
        mainDi.header.RemoveHeaderData(false);
        dispatch(mainDi.footer.setShowFooterUi(false));
        if (document.body.clientHeight + topValue === document.body.scrollHeight) {
            dispatch(mainDi.footer.updateShowMob_Menu(false));
        }
        else {
            dispatch(mainDi.footer.updateShowMob_Menu(false));
        }
    }, [topValue]);
    React.useEffect(() => {
        setJwtToken();
        dispatch(fetchAccountDetails());
        setJwtTokenForNestTrader();
        di.ticketData.getTicketsData();
    }, []);
    const ticketData = useSelector((state) => state.ticketPortal.TicketsReducer.data);
    const ticketDataError = useSelector((state) => state.ticketPortal.TicketsReducer.errorData);
    const createTicketData = useSelector((state) => state.ticketPortal.CreateDataReducer.data);
    const createTicketLoader = useSelector((state) => state.ticketPortal.CreateDataReducer.createTicketLoader);
    const createTicketError = useSelector((state) => state.ticketPortal.CreateDataReducer.errorData);
    if (createTicketData.message) {
        //setShowNewTicket('TicketPortal')
        localStorage.setItem("TicketSubmitSuccess", "true");
        location.reload();
    }
    // if (
    //   (createTicketData && createTicketData.message) || (createTicketError && createTicketError.isOpen)
    // ) {
    //   setSubmitTicket(false);
    // }
    React.useEffect(() => {
        switch (issueType.value) {
            case "AccountClosure":
                window.open(config.oldWebUrl + "app/clientarea/service-request/account-closure", "_blank");
                break;
            case "AddressModification":
                window.open(config.oldWebUrl +
                    "app/clientarea/service-request/address-modification", "_blank");
                break;
            case "BankModification":
                window.open(config.oldWebUrl + "app/clientarea/service-request/bank-modification", "_blank");
                break;
            case "ddpi":
                window.open(config.oldWebUrl + "app/clientarea/service-request/ddpi", "_blank");
                break;
            case "dpschemechange":
                window.open(config.oldWebUrl +
                    "clientarea/servicerequest?create-request&selectedVal=8", "_blank");
                break;
            case "fatca":
                window.open(config.oldWebUrl + "app/clientarea/service-request/fatcaUpdate", "_blank");
                break;
            case "incomedeclaration":
                window.open(config.oldWebUrl +
                    "clientarea/servicerequest?create-request&selectedVal=10", "_blank");
                break;
            case "mobileemailmodification":
                window.open(config.oldWebUrl +
                    "app/clientarea/service-request/email-mobile-modification?source=ajs", "_blank");
                break;
            case "nrmlsmtf":
                window.open(config.oldWebUrl + "app/clientarea/service-request/smtf", "_blank");
                break;
            case "NewDISBooklet":
                window.open(config.oldWebUrl +
                    "clientarea/servicerequest?create-request&selectedVal=7", "_blank");
                break;
            case "Nomination":
                window.open(config.oldWebUrl + "app/clientarea/service-request/nomination", "_blank");
                break;
            case "SegmentActivation":
                window.open(config.oldWebUrl +
                    "clientarea/servicerequest?create-request&selectedVal=9", "_blank");
                break;
            default:
                setCreateTicket(true);
        }
    }, [issueType]);
    const TicketSubmitSuccess = localStorage.getItem("TicketSubmitSuccess");
    return (React.createElement(React.Fragment, null,
        device && device.isDesktop ? (React.createElement(React.Fragment, null,
            React.createElement(GridContainer, { parentClass: "pt-3 bg-white" },
                React.createElement(Edelweisslogo, null)),
            React.createElement(GridContainer, { parentClass: "pb-3 backdrop-bg darkblack commonscroll-new" },
                React.createElement(Row, { className: "mgt-20" },
                    React.createElement(Col, { lg: 6, className: "px-0" },
                        React.createElement("span", { className: "DMSan_28_700" }, "Ticket"),
                        React.createElement("span", { className: "DMSansNormal_28_400 ms-2" }, "Portal")),
                    React.createElement(Col, { lg: 6, className: "text-right d-flex justify-content-end px-0" },
                        React.createElement("div", { className: ticketDataError && ticketDataError.isOpen
                                ? "newticket-btn px-3 disabled"
                                : "newticket-btn px-3", onClick: () => setOpenNewTicket(true) },
                            React.createElement("span", { className: "edel-icon-ticket" }),
                            React.createElement("span", { className: "ps-2 DMSan_14_500" }, "New Ticket")))),
                ticketData && !ticketDataError.isOpen && (React.createElement(Row, null,
                    React.createElement(Col, { lg: 4, className: "mt-20 brd-all px-0" },
                        React.createElement("div", null,
                            React.createElement(TicketPortalTab, { data: searchFlag ? searchResult : ticketData === null || ticketData === void 0 ? void 0 : ticketData.list, selectTicket: setSelectedTicket, showNewTicket: showNewTicket, getTabWiseData: setTabWiseData, createNewTicketAlert: createNewTicketAlert }))),
                    React.createElement(Col, { lg: 8, className: "mt-20 px-0  brd-all brd-left-none" },
                        showNewTicket === "Ticketportal" && (React.createElement(React.Fragment, null,
                            React.createElement("div", { className: "commonscroll-new height400" }, ticketData && ticketData.list ? (ticketData.list.length > 0 ? (React.createElement(TicketPortalDesc, { ticketId: selectedTicket.ticketId
                                    ? selectedTicket.ticketId
                                    : ticketData === null || ticketData === void 0 ? void 0 : ticketData.list[0].ticketId, status: selectedTicket.ticketId
                                    ? selectedTicket.status
                                    : ticketData === null || ticketData === void 0 ? void 0 : ticketData.list[0].status, desc: selectedTicket.ticketId
                                    ? selectedTicket.desc
                                    : ticketData === null || ticketData === void 0 ? void 0 : ticketData.list[0].description, ticketDate: selectedTicket.ticketId
                                    ? selectedTicket.ticketDate
                                    : ticketData === null || ticketData === void 0 ? void 0 : ticketData.list[0].createdDate, comments: selectedTicket.ticketId
                                    ? selectedTicket.comments
                                    : ticketData === null || ticketData === void 0 ? void 0 : ticketData.list[0].comments, closedDate: selectedTicket.ticketId
                                    ? selectedTicket.closedDate
                                    : ticketData === null || ticketData === void 0 ? void 0 : ticketData.list[0].closedDate, createTicketStatus: createTicketData })) : (React.createElement("div", { className: "commonscroll-new height400 aligncenteritem" },
                                React.createElement("div", { className: "commonscroll-new height400 aligncenteritem" },
                                    React.createElement(TicketportalError, { errorMsg: "No tickets created", iconBig: true, onClick: () => {
                                            setNewTicketAlert(false);
                                            setOpenNewTicket(true);
                                        } }))))) : (React.createElement("div", { className: "overlay" },
                                React.createElement(Row, { className: "mx-0  aligncenteritem height400" },
                                    React.createElement(Col, { lg: 12, className: "" },
                                        React.createElement("div", { className: "d-flex justify-content-center" },
                                            React.createElement("img", { src: loader, className: "loader-height" }))))))))),
                        showNewTicket === "newticket" && (React.createElement(React.Fragment, null,
                            React.createElement("div", { className: "commonscroll-new height460 newticket-section " },
                                React.createElement(NewTicket, { submitFlag: submitFlag, getTotalFileSize: getTotalFileSize, changeSubmitFlag: setSubmitFlag, getDescription: getDescription, getTotalAttachment: getTotalAttachment, getCounter: getCounter }),
                                createTicketLoader && (React.createElement(React.Fragment, null,
                                    React.createElement("div", { className: "overlay" },
                                        React.createElement(Row, { className: "mx-0  aligncenteritem height400" },
                                            React.createElement(Col, { lg: 12, className: "" },
                                                React.createElement("div", { className: "d-flex justify-content-center" },
                                                    React.createElement("img", { src: loader, className: "loader-height" })),
                                                React.createElement("p", { className: "DMSan_14_700 txt_blackOne1 mgt-50 d-flex justify-content-center" }, "Submitting Ticket")))))),
                                device &&
                                    device.isDesktop &&
                                    createTicketError &&
                                    createTicketError.isOpen && (React.createElement(React.Fragment, null,
                                    React.createElement("div", { className: "overlay" },
                                        React.createElement(Row, { className: "mx-0  aligncenteritem height400" },
                                            React.createElement(Col, { lg: 12, className: "" },
                                                React.createElement("div", { className: "d-flex justify-content-center" },
                                                    React.createElement("img", { src: tiketsub })),
                                                React.createElement("p", { className: "DMSan_14_700 txt_blackOne1 mgt-20 d-flex justify-content-center" }, "Ticket submission failed due to a technical issue"),
                                                React.createElement("p", { className: "text-center" },
                                                    React.createElement("span", { className: "edel-icon-refresh  ps-2" }),
                                                    React.createElement("span", { className: "ps-2 DMSan_14_700 txt-midnight-blue hand_cursor", onClick: () => {
                                                            showNewTicketVisible("Ticketportal");
                                                            location.reload();
                                                        } }, "Retry")))))))),
                            React.createElement(Row, { className: "brd-top mx-0 btn-newticket posrel" },
                                submitTicket && (React.createElement(React.Fragment, null,
                                    React.createElement("div", { className: "overlay" }))),
                                ticketSubmitFail && (React.createElement(React.Fragment, null,
                                    React.createElement("div", { className: "overlay" }))),
                                React.createElement(Col, { lg: 12, className: "d-flex d-center-end gap-20" },
                                    React.createElement(EdButton, { btnTyp: "white-twenty", value: "Discard", className: "small-edbutton blood-red-border px-0", onClick: () => setTicketLost(true) }),
                                    React.createElement(EdButton, { btnTyp: "midnight-blue", value: "Submit Ticket", className: "small-edbutton px-0", onClick: () => {
                                            if (totalFileSize > 5120) {
                                                setFinalCheck(false);
                                            }
                                            else {
                                                setFinalCheck(true);
                                                //setfinalSizeExceed(false)
                                            }
                                        }, disabled: !description ||
                                            countcharcter >= 1000 ||
                                            totalAttachment > 5 })))))))),
                finalCheck && (React.createElement(React.Fragment, null,
                    React.createElement(EdModal, { show: finalCheck, setShow: setFinalCheck, showFooter: false, title: "Final Check", modalTitle: `commonmodal gray-modal`, size: "modal-lg-700 modal-dialog-centered" },
                        React.createElement(React.Fragment, null,
                            React.createElement(Row, { className: "d-flex justify-content-center" },
                                React.createElement(Col, { lg: 12, className: "px-3" },
                                    React.createElement("span", { className: "DMSans_16_500 txt_blackOne1" }, "Please ensure you\u2019ve captured all the details and uploaded necessary attachments in your ticket. You will not be able to make any changes once the ticket is submitted.")),
                                React.createElement(Col, { lg: 12, className: "mgt-40 px-5 pb-3" },
                                    React.createElement(Row, null,
                                        React.createElement(Col, { lg: 6 },
                                            React.createElement(EdButton, { btnTyp: "midnight-blue-border", value: "Check Again", className: "w-100", onClick: () => {
                                                    setFinalCheck(false);
                                                } })),
                                        React.createElement(Col, { lg: 6 },
                                            React.createElement(EdButton, { btnTyp: "midnight-blue", value: "Submit Ticket", className: "w-100", onClick: () => {
                                                    setSubmitFlag(true);
                                                    setSubmitTicket(true);
                                                    setFinalCheck(false);
                                                } }))))))))),
                ticketLost && (React.createElement(React.Fragment, null,
                    React.createElement(EdModal, { show: ticketLost, setShow: setTicketLost, showFooter: false, title: "Warning", modalTitle: `commonmodal gray-modal`, size: "modal-lg-660 modal-dialog-centered" },
                        React.createElement(React.Fragment, null,
                            React.createElement(Row, { className: "d-flex justify-content-center" },
                                React.createElement(Col, { lg: 12, className: "px-5 text-center" },
                                    React.createElement("span", { className: "DMSans_16_500 txt_blackOne1 text-center" }, "Data in new ticket will be lost if you view other ticket")),
                                React.createElement(Col, { lg: 12, className: "mgt-40 px-5 pb-3" },
                                    React.createElement(Row, null,
                                        React.createElement(Col, { lg: 6 },
                                            React.createElement(EdButton, { btnTyp: "midnight-blue-border", value: "Discard New Ticket", className: "w-100 px-0", onClick: () => {
                                                    showNewTicketVisible("Ticketportal");
                                                    setTicketLost(false);
                                                } })),
                                        React.createElement(Col, { lg: 6 },
                                            React.createElement(EdButton, { btnTyp: "midnight-blue", value: "Continue Editing", className: "w-100 px-0", onClick: () => setTicketLost(false) })))))))))))) : (React.createElement(React.Fragment, null,
            React.createElement(GridContainer, { parentClass: "pb-3 bg-white" },
                React.createElement(Row, { className: " d-flex align-items-center" },
                    React.createElement(Col, { lg: 6, className: "col-6" },
                        React.createElement("span", { className: "DMSansMedium_20_500 txt-midnight-blue" }, "Ticket Portal")),
                    React.createElement(Col, { lg: 6, className: "text-right d-flex justify-content-end col-6" },
                        React.createElement("div", { className: ticketDataError && ticketDataError.isOpen
                                ? "newticket-btn px-3 disabled"
                                : "newticket-btn px-3", onClick: () => setOpenNewTicket(true) },
                            React.createElement("span", { className: "edel-icon-ticket" }),
                            React.createElement("span", { className: "ps-2 DMSan_14_500" }, "Create")))),
                TicketSubmitSuccess == "true" && (React.createElement(React.Fragment, null,
                    React.createElement(Row, { className: "mx-0" },
                        React.createElement(Col, { lg: 12, className: "errormsg-ticketpotal d-space-between mt-3" },
                            React.createElement("div", { className: "ticket-grid-1-2 ms-2" },
                                React.createElement("span", { className: "edel-icon-checked-half-circle pe-2 txt_green" }),
                                React.createElement("span", { className: "DMSansNormal_12_400 txt-orange-light" }, "Your ticket has been successfully created. We're on it, working to resolve it swiftly.")),
                            React.createElement("div", { className: "d-flex", onClick: () => {
                                    localStorage.removeItem("TicketSubmitSuccess");
                                    setShowError(false);
                                } },
                                React.createElement("span", { className: "edel-icon-cross text-right txt-orange-light" })))))),
                React.createElement(Row, null,
                    React.createElement(Col, { lg: 12, className: "mt-20 brd-all px-0 mb-brd-all-none " },
                        React.createElement("div", null,
                            React.createElement(TicketPortalTab, { data: searchFlag ? searchResult : ticketData === null || ticketData === void 0 ? void 0 : ticketData.list, selectTicket: setSelectedTicket, showNewTicket: showNewTicket, getTabWiseData: setTabWiseData, createNewTicketAlert: createNewTicketAlert }))))))),
        ticketDataError && ticketDataError.isOpen ? (React.createElement(ErrorNotification, { displayType: ErrorDisplayType.INSECTION, isOpen: ticketDataError.isOpen, error: ticketDataError.error })) : (!ticketData && (React.createElement("div", { className: "overlay" },
            React.createElement(Row, { className: "mx-0  aligncenteritem height400" },
                React.createElement(Col, { lg: 12, className: "" },
                    React.createElement("div", { className: "d-flex justify-content-center" },
                        React.createElement("img", { src: loader, className: "loader-height" }))))))),
        (openNewTicket || newTicketAlert) && (React.createElement(React.Fragment, null, device && device.isDesktop ? (React.createElement(EdModal, { show: openNewTicket || newTicketAlert, setShow: setOpenNewTicket, showFooter: false, title: "Before you create a ticket", modalTitle: `commonmodal gray-modal`, size: "modal-lg-700 modal-dialog-centered", closeDropdown: () => {
                setOpenNewTicket(false);
                createNewTicketAlert(false);
            } },
            React.createElement(React.Fragment, null,
                React.createElement(Row, { className: "d-flex justify-content-center" },
                    React.createElement(Col, { lg: 12, className: "px-3" },
                        React.createElement("span", { className: "DMSans_16_500 txt_blackOne1" }, "Please check if your issue is listed below. If not, select the option \u201CMy issue is not listed\u201D below and proceed.")),
                    React.createElement(Col, { lg: 8, className: "mgt-30" },
                        React.createElement(EquityDropdown, { itemlist: TicketPortalIssue, defaultVal: true, selectedValue: (items) => {
                                setIssueType(items);
                            }, selectedDefaultVal: issueType, externalClassname: "common-new-drp  common-dropdown-new height37 w-100 commonscroll-new", bigIcon: false, align: "start" })),
                    React.createElement(Col, { lg: 12, className: "mgt-40 px-5 pb-3" },
                        React.createElement(Row, null,
                            React.createElement(Col, { lg: 6 },
                                React.createElement(EdButton, { btnTyp: "midnight-blue-border", value: "Cancel", className: "w-100", onClick: () => {
                                        setOpenNewTicket(false);
                                        createNewTicketAlert(false);
                                    } })),
                            React.createElement(Col, { lg: 6 },
                                React.createElement(EdButton, { btnTyp: "midnight-blue", value: "Create New Ticket", className: "w-100", onClick: () => {
                                        setNewTicketAlert(false);
                                        setOpenNewTicket(true);
                                        showNewTicketVisible("newticket");
                                        setShowNewTicket("newticket");
                                    }, disabled: issueType.value !== "Myissue" })))))))) : (React.createElement(React.Fragment, null,
            React.createElement(GenericDrawer, { show: openNewTicket || newTicketAlert, setShow: setOpenNewTicket, parentClass: "z-index-high", headerComp: React.createElement(React.Fragment, null,
                    React.createElement("label", { className: "term-heading DMSan_16_700 txt_blackOne1" }, "Before you create a ticket")), bodyComp: React.createElement(React.Fragment, null,
                    React.createElement("div", { className: "commonscroll-new" },
                        React.createElement("div", { className: "p-3" },
                            React.createElement(Row, { className: "commonlineheight-mb" },
                                React.createElement(Col, { lg: 12, className: "DMSan_14_500 pb-2" }, "Please check if your issue is listed below. If not, select the option \u201CMy issue is not listed\u201D below and proceed.")),
                            React.createElement(Row, null,
                                React.createElement(Col, { lg: 12, className: "px-0 mobile-pd" },
                                    React.createElement(CreateTicket, { setTicketType: setIssueType }))))),
                    React.createElement("div", { className: "bottom-contents topboxsshadow-button" },
                        React.createElement(Row, { className: "mx-0" },
                            React.createElement(Col, { lg: 6, xs: 6, className: "ps-3" },
                                React.createElement(EdButton, { btnTyp: "midnight-blue-border", value: "Cancel", className: "w-100", onClick: () => setOpenNewTicket(false) })),
                            React.createElement(Col, { lg: 6, xs: 6, className: "pe-3 px-0" },
                                React.createElement(EdButton, { btnTyp: "midnight-blue", value: "Create Service Request", className: "w-100 createservicereq-btn", onClick: () => {
                                        navigate("/new-ticket");
                                    }, disabled: issueType.value !== "Myissue" }))))) })))))));
};
export default TicketPortal;
{
    /***********  for error msg right side screen 77 ***************************/
}
{
    /* <div className="commonscroll-new height400 aligncenteritem">
                <TicketportalError
                  errorMsg={"No tickets created"}
                  errorDesc={errormsgDescError}
                  iconBig={true}
                />
              </div> */
}
{
    /***********  for error msg left side ***************************/
}
{
    /* <div className="commonscroll-new height400 aligncenteritem">
                <TicketportalError
                  errorMsg={"No tickets created"}
                  errorDesc={errormsgDescError}
                  iconSmall={true}
                />
              </div> */
}
{
    /* /********************** screen 82****************************** */
}
{
    /* <div className="overlay">
                  <Row className="mx-0  aligncenteritem height400">
                    <Col lg={12} className="">
                      <div className="d-flex justify-content-center">
                        <img src={loader} />
                      </div>
                      <p className="DMSan_14_700 txt_blackOne1 mgt-50 d-flex justify-content-center">
                        Submitting Ticket
                      </p>
                    </Col>
                  </Row>
                </div> */
}
{
    /* /********************** screen 93****************************** */
    {
        /* Ticket error 94  */
    }
    {
        /* <Row className="mx-0">
                    <Col lg={12} className="errormsg-ticketpotal">
                      <span className="DMSanN_14_400 txt-orange-light">
                        Your ticket has been successfully created. We're on it,
                        working to resolve it swiftly.
                      </span>
                    </Col>
                  </Row> */
    }
    {
        /* end Ticket error  */
    }
}
{
    /* </div>
              <div className="newticket-section posrel">
                {/* /********************** screen 87 to 92****************************** */
}
{
    /* <div className="commonscroll-new height400">
                  <NewTicket />
                </div> */
}
/**********screen 93************************** */
// <div className="overlay">
//               <Row className="mx-0  aligncenteritem height400">
//                 <Col lg={12} className="">
//                   <div className="d-flex justify-content-center">
//                     <img src={tiketsub} />
//                   </div>
//                   <p className="DMSan_14_700 txt_blackOne1 mgt-20 d-flex justify-content-center">
//                     Ticket submission failed due to a technical issue
//                   </p>
//                   <p className="text-center">
//                     <span className="edel-icon-refresh  ps-2"></span>
//                     <span className="ps-2 DMSan_14_700 txt-midnight-blue">
//                       Retry
//                     </span>
//                   </p>
//                 </Col>
//               </Row>
//             </div>
